import {
  Document,
  Page,
  View,
  Text,
  pdf,
  Font,
  Image,
  Link,
} from "@react-pdf/renderer";
import logo from "assets/img/logo.png";
import cta from "assets/img/cta_mvc.png";
import ctaen from "assets/img/cta_mvc_en.png";
import thankupl from "assets/img/thanku_pl.png";
import thankuen from "assets/img/thanku_pl.png";
import { styles } from "views/Step4.styles";
import Step4Data from "data/Step4Data";
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    },
  ],
});
export const PdfGeneratorAndSubmit = (
  lang,
  priceValue,
  roi,
  summary,
  Acalc,
  Bcalc,
  Ccalc,
  Dcalc,
  Ecalc,
  email,
  chartImage
) => {
  const handleGeneratePdfAndSubmit = async () => {
    let pdfdata;
    let notdefined;
    if (lang === "pl") {
      notdefined = Step4Data.notdefined.pl;
      pdfdata = Step4Data.pdfdata.pl;
    } else {
      notdefined = Step4Data.notdefined.en;
      pdfdata = Step4Data.pdfdata.en;
    }
    function mergeData(pdfdata, summary) {
      summary.forEach((summaryItem) => {
        const matchingIndex = pdfdata.findIndex(
          (pdfItem) => pdfItem.challenge.id === summaryItem.challenge.id
        );
        if (matchingIndex !== -1) {
          pdfdata[matchingIndex] = summaryItem;
        } else {
          pdfdata.push(summaryItem);
        }
      });
      return pdfdata;
    }
    pdfdata = mergeData(pdfdata, summary);
    const currentDate = new Date().toLocaleString();
    // Generate the PDF
    const pdfBlob = await pdf(
      <Document>
        <Page width="400px" size="A4" style={styles.page} wrap>
          <View style={styles.logowrapper}>
            <View>
              <Image src={logo} style={styles.image} />
            </View>
            <View>
              <Text style={styles.contactinfo}>
                {Step4Data.contact.name}
                {"\n"}
                {lang === "pl"
                  ? Step4Data.contact.address.pl
                  : Step4Data.contact.address.en}
                {"\n"}
                {Step4Data.contact.addresscd}
                {"\n"}
                {Step4Data.contact.nip}
                {"\n"}
                <Link
                  style={styles.mail}
                  src={`mailto:${Step4Data.contact.mail}`}
                >
                  {Step4Data.contact.mail}
                </Link>
              </Text>
            </View>
          </View>
          <View>
            <Text style={styles.title}>
              {lang === "pl" ? Step4Data.title.pl : Step4Data.title.en}
            </Text>
            <Text style={styles.subtitle}>
              {lang === "pl" ? Step4Data.subtitle.pl : Step4Data.subtitle.en}
            </Text>
            <View style={styles.data}>
              <Text style={styles.datatxt}>
                {lang === "pl"
                  ? Step4Data.currentdate.pl
                  : Step4Data.currentdate.en}{" "}
                {currentDate} - {email}
              </Text>
            </View>
            {pdfdata &&
              pdfdata.slice(0, 2).map(({ challenge, inputs }, index) => (
                <View style={styles.table} key={index}>
                  <Text style={styles.headerCell}>{challenge.name}</Text>
                  {challenge.id === "A" && (
                    <View wrap={false}>
                      {inputs.map((field) => (
                        <View key={field.id} style={styles.tableCell}>
                          <Text>
                            {field.label}{" "}
                            {isNaN(field.value)
                              ? notdefined
                              : Number(field.value).toLocaleString("pl-PL", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}{" "}
                            {field.unit}
                          </Text>
                        </View>
                      ))}

                      <Text style={styles.summaryCell}>
                        {lang === "pl"
                          ? Step4Data.atitle.pl
                          : Step4Data.atitle.en}
                        &nbsp;
                        {isNaN(Acalc)
                          ? notdefined
                          : Acalc.toLocaleString("pl-PL", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        &nbsp;
                        {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                      </Text>
                      <Text style={styles.summaryCell}>
                        {lang === "pl"
                          ? Step4Data.atitley.pl
                          : Step4Data.atitley.en}
                        &nbsp;
                        {isNaN(Acalc)
                          ? notdefined
                          : (Acalc * 12).toLocaleString("pl-PL", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        &nbsp;
                        {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                      </Text>
                    </View>
                  )}
                  {challenge.id === "B" && (
                    <View wrap={false}>
                      {inputs.map((field) => (
                        <View key={field.id} style={styles.tableCell}>
                          <Text>
                            {field.label}{" "}
                            {isNaN(field.value)
                              ? notdefined
                              : Number(field.value).toLocaleString("pl-PL", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}{" "}
                            {field.unit}
                          </Text>
                        </View>
                      ))}
                      <Text style={styles.summaryCell}>
                        {lang === "pl"
                          ? Step4Data.btitle.pl
                          : Step4Data.btitle.en}
                        &nbsp;
                        {isNaN(Bcalc)
                          ? notdefined
                          : Bcalc.toLocaleString("pl-PL", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        &nbsp;
                        {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                      </Text>
                      <Text style={styles.summaryCell}>
                        {lang === "pl"
                          ? Step4Data.btitley.pl
                          : Step4Data.btitley.en}
                        &nbsp;
                        {isNaN(Bcalc)
                          ? notdefined
                          : (Bcalc * 12).toLocaleString("pl-PL", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        &nbsp;
                        {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                      </Text>
                    </View>
                  )}
                </View>
              ))}
          </View>
        </Page>
        <Page width="400px" size="A4" style={styles.page} wrap>
          {pdfdata &&
            pdfdata.slice(2, 5).map(({ challenge, inputs }, index) => (
              <View style={styles.table} key={index}>
                <Text style={styles.headerCell}>{challenge.name}</Text>

                {challenge.id === "C" && (
                  <View wrap={false}>
                    {inputs.map((field) => (
                      <View key={field.id} style={styles.tableCell}>
                        <Text>
                          {field.label}{" "}
                          {isNaN(field.value)
                            ? notdefined
                            : Number(field.value).toLocaleString("pl-PL", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                          {field.unit}
                        </Text>
                      </View>
                    ))}
                    <Text style={styles.summaryCell}>
                      {lang === "pl"
                        ? Step4Data.ctitle.pl
                        : Step4Data.ctitle.en}
                      &nbsp;
                      {isNaN(Ccalc)
                        ? notdefined
                        : Ccalc.toLocaleString("pl-PL", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      &nbsp;
                      {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                    </Text>
                  </View>
                )}
                {challenge.id === "D" && (
                  <View wrap={false}>
                    {inputs.map((field) => (
                      <View key={field.id} style={styles.tableCell}>
                        <Text>
                          {field.label}{" "}
                          {isNaN(field.value)
                            ? notdefined
                            : Number(field.value).toLocaleString("pl-PL", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                          {field.unit}
                        </Text>
                      </View>
                    ))}
                    <Text wrap={false} style={styles.summaryCell}>
                      {lang === "pl"
                        ? Step4Data.dtitle.pl
                        : Step4Data.dtitle.en}
                      &nbsp;
                      {isNaN(Dcalc)
                        ? notdefined
                        : Dcalc.toLocaleString("pl-PL", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      &nbsp;
                      {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                    </Text>
                    <Text wrap={false} style={styles.summaryCell}>
                      {lang === "pl"
                        ? Step4Data.dtitley.pl
                        : Step4Data.dtitley.en}
                      &nbsp;
                      {isNaN(Dcalc)
                        ? notdefined
                        : (Dcalc * 12).toLocaleString("pl-PL", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      &nbsp;
                      {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                    </Text>
                  </View>
                )}
                {challenge.id === "E" && (
                  <View wrap={false}>
                    {inputs.map((field) => (
                      <View key={field.id} style={styles.tableCell}>
                        <Text>
                          {field.label}{" "}
                          {isNaN(field.value)
                            ? notdefined
                            : Number(field.value).toLocaleString("pl-PL", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                          {field.unit}
                        </Text>
                      </View>
                    ))}
                    <Text wrap={false} style={styles.summaryCell}>
                      {lang === "pl"
                        ? Step4Data.etitle.pl
                        : Step4Data.etitle.en}
                      &nbsp;
                      {isNaN(Ecalc)
                        ? notdefined
                        : Ecalc.toLocaleString("pl-PL", {
                            style: "decimal",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      &nbsp;
                      {lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
                    </Text>
                  </View>
                )}
              </View>
            ))}
          <Text wrap={false} style={styles.headerCell}>
            {lang === "pl" ? Step4Data.redbar.pl : Step4Data.redbar.en}
          </Text>
          <Text wrap={false} style={styles.summaryCell}>
            {lang === "pl" ? Step4Data.pricetext.pl : Step4Data.pricetext.en}{" "}
            {priceValue
              ? Number(priceValue).toLocaleString("pl-PL", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : 0}
            &nbsp;{lang === "pl" ? Step4Data.unit.pl : Step4Data.unit.en}
          </Text>
          <View>
            <Text
              wrap={false}
              style={[
                styles.summaryCellRoi,
                roi <= 36 ? { color: "#27ae60" } : null,
              ]}
            >
              {lang === "pl" ? Step4Data.roi.pl : Step4Data.roi.en}{" "}
              {roi
                ? roi.toLocaleString("pl-PL", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : 0}{" "}
              ({lang === "pl" ? Step4Data.month.pl : Step4Data.month.en})
            </Text>
          </View>
          <Text style={styles.pagenumber}>2</Text>
        </Page>
        <Page width="400px" size="A4" style={styles.page} wrap>
          {" "}
          <View wrap={false}>
            {chartImage && (
              <View wrap={false} style={styles.chart}>
                {roi && <Image src={chartImage} />}
              </View>
            )}
            {lang === "pl" && (
              <View>
                <Link src="https://mv-center.com/skonsultuj-wdrozenie/">
                  <Image src={cta} style={styles.cta} />
                </Link>
              </View>
            )}
            {lang === "en" && (
              <View>
                <Link src="https://mv-center.com/en/consult-implementation/">
                  <Image src={ctaen} style={styles.cta} />
                </Link>
              </View>
            )}
            {lang === "pl" && (
              <View>
                <Image src={thankupl} style={styles.thanku} />
              </View>
            )}
            {lang === "en" && (
              <View>
                <Image src={thankuen} style={styles.thanku} />
              </View>
            )}
          </View>
          <Text style={styles.pagenumber}>3</Text>
        </Page>
      </Document>
    ).toBlob();

    let domain = email.split("@");
    let domainParts = domain[1].split(".");
    const now = new Date();
    const year = now.getFullYear();
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const day = ("0" + now.getDate()).slice(-2);

    const formattedDate = month + "-" + day + "-" + year;
    const formData = new FormData();
    formData.append("yourEmail", email);
    formData.append(
      "pdf",
      pdfBlob,
      `MVC-Kalkulator-ROI-Systemu-Wizyjnego-${formattedDate}-${domainParts[0]}.pdf`
    );
    let url;
    if (lang === "pl") {
      url =
        "https://mv-center.com/wp-json/contact-form-7/v1/contact-forms/1862/feedback/";
      // url =
      //   "https://mvcenter.studionext.pl/wp-json/contact-form-7/v1/contact-forms/1862/feedback/";
    } else {
      url =
        "https://mv-center.com/wp-json/contact-form-7/v1/contact-forms/1863/feedback/";
      // url =
      //   "https://mvcenter.studionext.pl/wp-json/contact-form-7/v1/contact-forms/1863/feedback/";
    }

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
    } else {
      console.log("Error");
    }
  };
  handleGeneratePdfAndSubmit();
};
